const complaint = {
    list: () => 'getAllIssueReports',
    create: () => 'create/offer',
    getById: (id) => `getIssueReportById/${id}`,
    updateById: (id) => `/update/complaint/${id}`,
}
export default complaint
